export default {
  color: 'text',
  background: theme => theme.colors.background,
}
